/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const SearchSparkle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Search sparkle"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M16 16c.39-.39.846-.568 1.236-.178l4.471 4.471a1 1 0 1 1-1.414 1.414l-4.47-4.47c-.391-.391-.213-.846.177-1.237"
      />
      <path
        fill="#0E0E0E"
        d="M17.883 10.941a6.942 6.942 0 1 0-6.942 6.942v2l-.46-.012a8.94 8.94 0 0 1-8.47-8.47L2 10.941A8.94 8.94 0 0 1 10.941 2l.46.012a8.94 8.94 0 0 1 8.482 8.93l-.012.46a8.94 8.94 0 0 1-8.93 8.48v-2a6.94 6.94 0 0 0 6.942-6.94"
      />
      <path
        fill="#0E0E0E"
        d="M10.66 7.258c.096-.344.584-.344.68 0l.316 1.125a2.83 2.83 0 0 0 1.961 1.96l1.125.316c.344.097.344.585 0 .682l-1.125.315a2.83 2.83 0 0 0-1.96 1.961l-.316 1.125c-.097.344-.585.344-.682 0l-.315-1.125a2.83 2.83 0 0 0-1.961-1.96l-1.125-.316c-.344-.097-.344-.585 0-.682l1.125-.315a2.83 2.83 0 0 0 1.96-1.961z"
      />
    </g>
  </svg>
);

export const SearchSparkleIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'search-sparkle-icon'}
      icon={SearchSparkle}
      {...props}
      size={size}
    />
  );
};
